module.exports = __webpack_public_path__ + "img/0Q3A5801_L_WoodMatted.b5683457.jpg";